export default __webpack_public_path__ + "static/media/comunicate-con-nosotros.61ef6e10.svg";